import { Inject, Injectable } from '@angular/core';
import { CommonsSessionStorageService, downgradeToAJSService } from 'ib-web-commons/utils';
import { newAncillariesConstants } from '../../../../../../ib-web-new-ancillaries-constants';
import { AJSCommonsGenericProxyService, AJSCommonsGenericProxyServiceType } from '../../../../../shared/upgraded/commons-proxy-bridge.service';
import { CommonsNewHttpUtilsErrorService } from 'ib-web-commons/app/core/utils/http-utils-services/ib-commons-new-http-utils-error-service';

@Injectable(
    // {
    //   providedIn: 'root'
// }
)
export class IbGlobickService {

    constructor (
        private localStorageService: CommonsSessionStorageService,
        @Inject(AJSCommonsGenericProxyService) private CommonsGenericProxy: AJSCommonsGenericProxyServiceType
        // private commonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService
              
    ) { }

    registerClickGlobickProduct (product: string): void {
        const flowId = this.localStorageService.get('flowId');
        const uri = newAncillariesConstants.DEFAULT_ENDPOINTS.defaultGlobickURI + flowId + '/click/' + product;

        if (flowId !== null) {
            this.CommonsGenericProxy.postGeneric(uri, null).then(
                () => {},
                () => {}
            );
        }
    }
}

downgradeToAJSService('IbGlobickService', IbGlobickService, 'ib-web-ancillaries-module');

